import { render } from "./add-form.vue?vue&type=template&id=5779e9fc&scoped=true"
import script from "./add-form.vue?vue&type=script&lang=js"
export * from "./add-form.vue?vue&type=script&lang=js"

import "./add-form.vue?vue&type=style&index=0&id=5779e9fc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5779e9fc"]])

export default __exports__